import { EnumBase } from 'hay-core-react';
class UsuarioPinTipoEnum extends EnumBase {
    constructor() {
        super([
            'main.usuariopin.tipo.resetsenha',
            'main.usuariopin.tipo.cadastro',
            'main.usuariopin.tipo.login',
        ]);
    }
}

const instance = new UsuarioPinTipoEnum();
export default instance;
